export enum ProductStatus {
    BOOKED = 'booked',
    PENDING = 'pending',
    NOT_BOOKED = 'notBooked',
}
